<template>
    <div class="container-fluid p-3 p-md-4">
        <div class="d-flex flex-column flex-md-row justify-content-between align-items-stretch align-items-md-center mb-4 mb-md-5">
            <h3 class="font-weight-600 text-dark mb-0">
                <i class="fad fa-house text-primary fa-fw mr-3"/>Odběrná místa
            </h3>
        </div>

        <SupplyPointMobileList/>
    </div>
</template>

<script>
import SupplyPointMobileList from "../../SupplyPoint/Component/SupplyPointMobileList.vue"

export default {

    components: {
        SupplyPointMobileList,
    },

}
</script>
